export const SuccessUploadIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.5 11.6875L9.5 14.6875L15.5 8.6875M21 11.6875C21 17.2103 16.5228 21.6875 11 21.6875C5.47715 21.6875 1 17.2103 1 11.6875C1 6.16465 5.47715 1.6875 11 1.6875C16.5228 1.6875 21 6.16465 21 11.6875Z"
        stroke="#26BF56"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
